import React from 'react'
import Tab from 'react-bootstrap/Tab'
import Tabs from 'react-bootstrap/Tabs'
import SkillsTab from './SkillsTab'
import Row from 'react-bootstrap/Row'
import {Jumbotron} from './migration'
import {Container} from 'react-bootstrap'
import {useScrollPosition} from '../../hooks/useScrollPosition'

const Skills = React.forwardRef(({heading, hardSkills, softSkills}, ref) => {
        const skillsTabRef = React.useRef(null)
        const [isScrolled, setIsScrolled] = React.useState(false)

        useScrollPosition(
            ({currPos}) => {
                if (!isScrolled && currPos.y - 400 < 0) {
                    setIsScrolled(true)
                }
            },
            [],
            skillsTabRef
        )
        return (
            <Jumbotron className="bg-white m-0" id="skills" fluid ref={skillsTabRef}>
                <Container className="p-5 ">
                    <h2 className="display-4 pb-5 text-center" ref={skillsTabRef}>
                        {heading}
                    </h2>
                    <Tabs
                        className="skills-tabs"
                        defaultActiveKey="hard-skills"
                        fill
                        id="skills-tabs"
                    >
                        <Tab
                            eventKey="hard-skills"
                            tabClassName="skills-tab lead"
                            title="Technical Skills"
                        >
                            <Row className="pt-3 px-1">
                                <SkillsTab
                                    isScrolled={isScrolled}
                                    skills={hardSkills}
                                />
                            </Row>
                        </Tab>
                        <Tab
                            eventKey="soft-skills"
                            tabClassName="skills-tab lead"
                            title="Soft Skills"
                        >
                            <Row className="pt-3 px-1">
                                <SkillsTab
                                    isScrolled={isScrolled}
                                    skills={softSkills}
                                />
                            </Row>
                        </Tab>
                    </Tabs>
                </Container>
            </Jumbotron>
        )
    }
)

export default Skills